import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { getRangeFromDateFilter } from 'utils/dateUtils'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { addToast } from 'containers/Toasts/actions'

import { epicsErrorHandler } from '../../../epics'

import {
  cloneGroupSettingsError,
  cloneGroupSettingsSuccess,
  deleteGroupSettingsError,
  deleteGroupSettingsSuccess,
  fetchGroupSettingsError,
  fetchGroupSettingsSuccess,
  setGroupSettingsAsDefaultError,
  setGroupSettingsAsDefaultSuccess,
} from './actions'
import {
  CLONE_GROUP_SETTINGS_REQUEST_ASYNC,
  DELETE_GROUP_SETTINGS_REQUEST_ASYNC,
  FILTERS_SUBMIT,
  GROUP_SETTINGS_DATA_REQUEST_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC,
  SORT_PROPERTY_CHANGE,
} from './constants'

const fetchGroupSettingsEpic = (action$, store, { api }) =>
  action$
    .ofType(
      GROUP_SETTINGS_DATA_REQUEST_ASYNC.INITIATE,
      CLONE_GROUP_SETTINGS_REQUEST_ASYNC.SUCCESS,
      DELETE_GROUP_SETTINGS_REQUEST_ASYNC.SUCCESS,
      SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC.SUCCESS,
      SORT_PROPERTY_CHANGE,
      FILTERS_SUBMIT,
      PAGINATE_CHANGE,
      SEARCH_CHANGE
    )
    .mergeMap(() =>
      api.groupSettings
        .getGroupSettingsTableData(
          store.getState().groupsettings.self.page,
          store.getState().groupsettings.self.sortProperty,
          store.getState().groupsettings.self.filters?.assignedFilter,
          store.getState().groupsettings.self.filters?.updatedByFilter,
          getRangeFromDateFilter(store.getState().groupsettings.self.filters?.lastUpdatedFilter),
          store.getState().groupsettings.self.search,
          store.getState().partnerOptions.selectedCompany?.value
        )
        .map((response) => fetchGroupSettingsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchGroupSettingsError, error)))
        .takeUntil(action$.ofType(GROUP_SETTINGS_DATA_REQUEST_ASYNC.CANCEL))
    )

const cloneGroupSettingsEpic = (action$, store, { api }) =>
  action$.ofType(CLONE_GROUP_SETTINGS_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.groupSettings
      .cloneGroupSettings(store.getState().partnerOptions.selectedCompany?.value, {
        groupSettingsId: action.payload.id,
      })
      .mergeMap(({ response }) =>
        Observable.of(
          cloneGroupSettingsSuccess(response),
          addToast({ message: 'Cloned successfully!' })
        )
      )
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(cloneGroupSettingsError, error),
          addToast({
            message: error.response?.message || error?.response,
            type: 'error',
          })
        )
      )
      .takeUntil(action$.ofType(CLONE_GROUP_SETTINGS_REQUEST_ASYNC.CANCEL))
  )

const deleteGroupSettingsEpic = (action$, store, { api }) =>
  action$.ofType(DELETE_GROUP_SETTINGS_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.groupSettings
      .deleteGroupSettings(store.getState().partnerOptions.selectedCompany?.value, {
        groupSettingsId: action.payload.id || store.getState().groupsettings.wizard.data.id,
      })
      .mergeMap(({ response }) =>
        Observable.of(
          deleteGroupSettingsSuccess(response),
          matchURL(URL_CONST.groupSettings.table) && addToast({ message: 'Deleted successfully!' })
        )
      )
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(deleteGroupSettingsError, error),
          matchURL(URL_CONST.groupSettings.table) &&
            addToast({
              message: error.response?.message || error?.response,
              type: 'error',
            })
        )
      )
      .takeUntil(action$.ofType(DELETE_GROUP_SETTINGS_REQUEST_ASYNC.CANCEL))
  )

const setGroupSettingsAsDefaultEpic = (action$, store, { api }) =>
  action$.ofType(SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.groupSettings
      .setGroupSettingsAsDefault(store.getState().partnerOptions.selectedCompany?.value, {
        groupSettingsId: action.payload.id,
        setAsDefault: action.payload.value,
      })
      .mergeMap(({ response }) =>
        Observable.of(
          setGroupSettingsAsDefaultSuccess(response),
          addToast({ message: 'Applied successfully!' })
        )
      )
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(setGroupSettingsAsDefaultError, error),
          addToast({
            message: error.response?.message || error?.response,
            type: 'error',
          })
        )
      )
      .takeUntil(action$.ofType(SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC.CANCEL))
  )

export default combineEpics(
  cloneGroupSettingsEpic,
  deleteGroupSettingsEpic,
  fetchGroupSettingsEpic,
  setGroupSettingsAsDefaultEpic
)
